import React from 'react';
import { useScrollProgress } from '../hooks/useScrollProgress';
export function ProgressBar() {
  const progress = useScrollProgress();
  return <div className="fixed top-[40px] left-0 w-full h-[3px] z-40" data-id="element-320">
      <div className="h-full bg-gradient-to-r from-primary to-primary-light transition-[width] duration-100 ease-linear" style={{
      width: `${progress}%`
    }} data-id="element-321" />
    </div>;
}